<template>
  <CRow>
    <CCol v-for="(value, index) of info.extension_info.values" :key="index">
      <CFormCheck
        :name="`${info.type}-${info.part_item_id}`"
        :id="`${info.type}-${info.part_item_id}-${index}`"
        :label="value"
        :value="value"
        @change="emitContent($event, value)"
        :checked="answerList && answerList?.indexOf(index) !== -1"
      />
    </CCol>
    <CCol>
      <div v-if="info.extension_info.last === '其他'">
        <CFormCheck
          :name="`${info.type}-${info.part_item_id}`"
          :id="`${info.type}-${info.part_item_id}-${info.extension_info.length}`"
          label="其他"
          :value="-1"
          :checked="answerList && answerList?.indexOf(-1) !== -1"
          @change="emitContent($event, -1)"
        />
        <CFormInput :disabled="(answerList.indexOf(-1) === -1)" class="col-12 mt-2" placeholder="請填寫其他內容" />
      </div>
    </CCol>
  </CRow>
</template>
<script>
import { ref } from 'vue'

export default {
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const answerList = ref([])
    const addOrRemove = (value) => {
      if (answerList.value === '') {
        answerList.value = []
      }
      if (String(value)) {
        console.log(answerList.value)
        const index = answerList.value.findIndex((e) => e === value)
        console.log(value, index)
        if (index < 0) {
          answerList.value.push(value)
        } else {
          answerList.value.splice(index, 1)
        }
      }
    }
    const emitContent = (e, item) => {
      let id = null
      if (item !== undefined) {
        id = props.info.extension_info.values.findIndex(
          (option) => option === item,
        )
        addOrRemove(item === -1 ? -1 : id)
      }
    }
    return {
      answerList,
      emitContent,
    }
  },
}
</script>
